import dateFormatType from '@/constants/dateFormatType';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
import { workerBaromoneyType } from '@/constants/workerBaromoneyHistory/workerBaromoneyHistoryOptionList';
import { workerBaromoneyHistoryWorkerStatusType } from '@/constants/workerBaromoneyHistory/workerBaromoneyHistoryWorkerStatusOptionList';
import { workerBaromoneySearchType } from '@/constants/workerBaromoneyHistory/workerBaromoneySearchTypeOptionList';
import { beforeDays } from '@/utils/time';
import { format } from 'date-fns';
const today = new Date();
const initialFromDate = format(beforeDays(today, 1), dateFormatType.DATE);
const initialToDate = format(today, dateFormatType.DATE);
const firstPage = 1;
export const getInitialState = () => ({
    filterOption: {
        fromDate: initialFromDate,
        toDate: initialToDate,
        workerStatus: workerBaromoneyHistoryWorkerStatusType.ACTIVE,
        workerBaromoneyType: workerBaromoneyType.WORKER_BAROMONEY_AUTO_DEDUCTION,
        searchType: workerBaromoneySearchType.WORKER_NAME,
        searchKey: null,
    },
    sortOption: [
        {
            // 정렬 대상
            field: '',
            // 정렬 기준
            value: '',
        },
    ],
    pageSize: pageSizeEnum['50'],
    pageNumber: firstPage,
    // 데이터
    workerBaromoneyHistoryList: [],
    paginationData: {},
});
const states = getInitialState();
export default states;
